import { render } from "./ResultWrapper.vue?vue&type=template&id=71bb6386&scoped=true"
import script from "./ResultWrapper.vue?vue&type=script&lang=js"
export * from "./ResultWrapper.vue?vue&type=script&lang=js"

import "./ResultWrapper.vue?vue&type=style&index=0&id=71bb6386&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bb6386"]])

export default __exports__